module.exports = __webpack_public_path__ + "315616e9fa7b7f3b2c739f5b75f9790c.csv";